import { render, staticRenderFns } from "./FlightSearchResultsLoader.vue?vue&type=template&id=b0299fd6&scoped=true&"
import script from "./FlightSearchResultsLoader.vue?vue&type=script&lang=js&"
export * from "./FlightSearchResultsLoader.vue?vue&type=script&lang=js&"
import style0 from "./FlightSearchResultsLoader.vue?vue&type=style&index=0&id=b0299fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0299fd6",
  null
  
)

/* custom blocks */
import block0 from "./FlightSearchResultsLoader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
